import { render, staticRenderFns } from "./AddNewSelectDocumentTypeDialog.vue?vue&type=template&id=2c8029d2&scoped=true&lang=pug&"
import script from "./AddNewSelectDocumentTypeDialog.vue?vue&type=script&lang=js&"
export * from "./AddNewSelectDocumentTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSelectDocumentTypeDialog.vue?vue&type=style&index=0&id=2c8029d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8029d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VIcon,VSpacer})
